import React from 'react';
import PropTypes from 'prop-types';
import { dataHooks } from './constants';
import ArrowRight from '../icons/arrowRight.svg.js';
import _Symbol from '../symbol';
import compose from '../../hoc/compose';

var DrillInListItem = function DrillInListItem(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('control-drill-in-list-item') + (props.disabled ? ' disabled' : '') + (props.contentAfter ? ' has-content-after' : ''),
    "data-aid": props.automationId,
    "data-hook": props.dataHook,
    onClick: props.disabled ? null : props.onClick,
    disabled: props.disabled
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, props.translateIfNeeded(props.label)), props.description ? /*#__PURE__*/React.createElement("div", {
    key: "description",
    className: "description",
    "data-hook": dataHooks.drillInListItemDescription
  }, props.translateIfNeeded(props.description)) : null), props.contentAfter ? /*#__PURE__*/React.createElement("div", {
    key: "contentAfter",
    className: "content-after"
  }, props.contentAfter) : null, /*#__PURE__*/React.createElement(_Symbol, {
    className: "symbol-arrowRight"
  }, /*#__PURE__*/React.createElement(ArrowRight, null)));
};

DrillInListItem.displayName = 'DrillInListItem';
DrillInListItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  contentAfter: PropTypes.element,
  disabled: PropTypes.bool
};
DrillInListItem.defaultProps = {
  disabled: false
};
export default compose(DrillInListItem);